// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.base-card{border:1px solid #000;padding:1rem;border-radius:.5rem}`, "",{"version":3,"sources":["webpack://./src/styles/BaseCard.scss"],"names":[],"mappings":"AAAA,WACE,qBAAA,CACA,YAAA,CACA,mBAAA","sourcesContent":[".base-card {\n  border: 1px solid black;\n  padding: 1rem;\n  border-radius: .5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
